import { render, staticRenderFns } from "./campo-apresentacao.vue?vue&type=template&id=74f77b97&scoped=true"
import script from "./campo-apresentacao.vue?vue&type=script&lang=js"
export * from "./campo-apresentacao.vue?vue&type=script&lang=js"
import style0 from "./campo-apresentacao.vue?vue&type=style&index=0&id=74f77b97&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f77b97",
  null
  
)

export default component.exports